import React from 'react';
import moment from 'moment';

const jobs = [
  {
    company: 'Netflix',
    role: 'Senior Software Engineer',
    start: 1522566000000,
  },
  {
    company: 'Designers.how',
    role: 'Co-Founder/Lead Engineer',
    start: 1462086000000,
  },
  {
    company: 'SAP Concur',
    role: 'Senior Software Engineer',
    start: 1456819200000,
    end: 1519891200000,
  },
  {
    company: 'Creativedash',
    role: 'Senior Developer',
    start: 1398927600000,
    end: 1456819200000,
  },
  {
    company: 'Wonderful Union',
    role: 'Lead Front-End Engineer',
    start: 1304233200000,
    end: 1398927600000,
  },
];

const getDate = (job) => {
  if (!job.end) {
    return `${moment(job.start).format('MMM YYYY')} to Present`;
  }

  const start = moment(job.start).format('MMM YYYY');
  const end = moment(job.end).format('MMM YYYY');

  return `${start} to ${end}`;
};

export default function Experience() {
  const experience = jobs.map(job => (
    <div className="job" key={job.company}>
      <h3 className="company">{job.company}</h3>
      <span className="role">{job.role}</span>
      <span className="duration">{getDate(job)}</span>
    </div>
  ));

  return (
    <div className="slide experience">
      <div className="container">
        {/* <h2>Experience</h2> */}
        {experience}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Experience.jsx